module.exports = __webpack_public_path__ + "videos/how-to-deposit.004db00.mp4";